module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAALZJREFUOE/l1CEKQkEQxvH/dwCbxYPYvIAYDCZBTF7DbLeJ2aZZk8l3CEEMr3oDQT5ZsPjwyT6YIm7d3d/szCwjgpeCPd5A22NgCbQzA92BLTCV9Eh3quANWAH7TLAF7ICRpMMn0EBPUpEJYvsKzCVtfhy0nerTrUm9lHRJe9kp254A6xrwKGnQCAxviu0O0K9+rVegs6RToxfaHgKLGrCQNGsEhqf8P2D4cIgdX7mN+HYufGI/AVrPqBUmeltjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/open/leftbar_icon_order_s.png
// module id = y27P
// module chunks = 1